import { useQuery } from "@tanstack/react-query";
import { Check, Circle, Hourglass } from "lucide-react";
import { get } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { STAFF } from "@/lib/nav";
import { NextActionButton } from "@/components/app/NextActionButton";

export function WhatsNext({ appId }) {
  const { user } = useAuth();
  const { data } = useQuery({ queryKey: ["next-step", appId], queryFn: () => get(`/applications/${appId}/next-step`), enabled: !!appId });
  if (!data) return null;
  const staff = STAFF.includes(user.role);
  return (
    <section className="panel grid gap-5 p-5 md:grid-cols-[1fr_auto]" data-testid="whats-next">
      <div className="space-y-2">
        <p className="text-[11px] font-medium uppercase tracking-[0.08em] text-ink-muted">What's next</p>
        <p className="text-sm text-ink" data-testid="whats-next-why">{data.next.why}</p>
        <NextActionButton row={data} canAct={staff || data.next.action === "decide"} />
      </div>
      <ol className="space-y-2 border-l border-line pl-4" aria-label="Progress" data-testid="progress-track">
        {data.track.map((t) => {
          const Icon = t.at ? Check : t.started ? Hourglass : Circle;
          return (
            <li key={t.n} className="flex items-center gap-2 text-sm" data-testid={`track-${t.n}`}>
              <Icon size={14} className={t.at ? "text-success" : t.started ? "text-caution" : "text-ink-muted"} aria-hidden />
              <span className={t.at ? "text-ink" : "text-ink-muted"}>{t.title}</span>
              {t.at && <span className="text-xs text-ink-muted">{new Date(t.at).toLocaleDateString()}</span>}
              {!t.at && t.started && <span className="text-xs text-ink-muted">in progress</span>}
            </li>
          );
        })}
      </ol>
    </section>
  );
}
